
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { CheckCircle, AlertCircle, AlertTriangle, Info } from "lucide-react";
import { ConnectionStatus, ConnectionState } from "./types";

interface ConnectionStatusAlertProps {
  connectionStatus: ConnectionStatus;
}

export const ConnectionStatusAlert: React.FC<ConnectionStatusAlertProps> = ({
  connectionStatus,
}) => {
  if (!connectionStatus.message) return null;

  switch (connectionStatus.state) {
    case ConnectionState.CONNECTED:
    case ConnectionState.SUCCESS:
      return (
        <Alert variant="default" className="mt-4 border-green-500/20 bg-green-500/5 text-green-600">
          <CheckCircle className="h-4 w-4" />
          <AlertTitle>Erfolgreich</AlertTitle>
          <AlertDescription>{connectionStatus.message}</AlertDescription>
        </Alert>
      );
      
    case ConnectionState.WARNING:
      return (
        <Alert variant="warning" className="mt-4 border-yellow-500/20 bg-yellow-500/5 text-yellow-600">
          <AlertTriangle className="h-4 w-4" />
          <AlertTitle>Warnung</AlertTitle>
          <AlertDescription>{connectionStatus.message}</AlertDescription>
        </Alert>
      );
      
    case ConnectionState.ERROR:
      return (
        <Alert variant="destructive" className="mt-4">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Fehler</AlertTitle>
          <AlertDescription>{connectionStatus.message}</AlertDescription>
        </Alert>
      );
    
    case ConnectionState.INITIAL:
    default:
      if (connectionStatus.message) {
        return (
          <Alert variant="default" className="mt-4 border-blue-500/20 bg-blue-500/5 text-blue-600">
            <Info className="h-4 w-4" />
            <AlertTitle>Info</AlertTitle>
            <AlertDescription>{connectionStatus.message}</AlertDescription>
          </Alert>
        );
      }
      return null;
  }
};
